import { RegistryObject } from "@mcleod/core";
import { AllowedUse } from "./AllowedUse";

export class AllowedUseAddlOption extends RegistryObject {
    private _parent: AllowedUse;
    private _key: string;
    private _descr: string;

    constructor(parent: AllowedUse, key: string, descr: string) {
        super();
        this._parent = parent;
        this._key = key;
        this._descr = descr;
    }

    public get parent(): AllowedUse {
        return this._parent;
    }

    public get key(): string {
        return this._key;
    }

    public get descr(): string {
        return this._descr;
    }

    override get type(): string {
        return this.key;
    }
}
